import {
  App,
  Book,
  Course,
  Movie,
  Podcast,
  Test,
  Article,
} from "../Components/Icons/Icons";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import HubIcon from "@mui/icons-material/Hub";

const WayMapper = {
  book: {
    title: "کتاب",
    icon: <Book />,
  },
  movie: {
    title: "فیلم",
    icon: <Movie />,
  },
  test: {
    title: "تست",
    icon: <Test />,
  },
  course: {
    title: "رویداد یا دوره",
    icon: <Course />,
  },
  podcast: {
    title: "پادکست",
    icon: <Podcast />,
  },
  app: {
    title: "نرم افزار یا سایت",
    icon: <App />,
  },

  article: {
    title: "مقاله",
    icon: <Article />,
  },
  game: {
    title: "بازی",
    icon: <SportsEsportsIcon />,
  },
  social: {
    title: "شبکه های اجتمایی",
    icon: <HubIcon />,
  },
};

export default WayMapper;
